module.exports = __webpack_public_path__ + "img/instructor.df8b5e5d.svg";